import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { SoggettoPratica } from "../../../common/models/tipologiche/soggetto-pratica";
import { TipoNatura } from "../../../common/models/tipologiche/tipo-natura";
import { TipoTipologica } from "../../../common/models/tipologiche/tipo-tipologica";
import { HelpersService } from "../../../core/services/helpers.service";
import { MetadataExt } from 'src/app/common/models/metadati/metadata';
import { ProtocolMetadata } from 'src/app/common/protocol/models/protocol';

@Component({
  selector: 'app-form-amianto',
  templateUrl: './form-amianto.component.html',
  styleUrls: ['./form-amianto.component.css']
})
export class FormAmiantoComponent implements OnInit, OnChanges {

  datiGeneraliForm: FormGroup;
  soggettiOptions: SoggettoPratica[] = [];
  foriOptions: TipoTipologica[] = [];
  tipiNatura: TipoNatura[] = [];
  naturaSelected: TipoNatura;
  metadataFormValid: boolean = false;
  protocollo: ProtocolMetadata;

  @Input() fascicolo;
  @Input() request;
  @Input() nomeFascicolo;
  @Input() labelCreatoDaSistema;
  @Input() minervaWizard = false;
  @Output() saveForm = new EventEmitter();
  @Output() resetForm = new EventEmitter();
  // @Output() tipoRichiedenteChanged = new EventEmitter();
  @Output() createForm = new EventEmitter();
  formValidationService: any;

  constructor(private campiForm: FormBuilder, private helpers: HelpersService) { }

  ngOnInit() {
    this.createFascicoloForm(true);
    this.populateSelect();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.request && changes.request.currentValue) {
      this.createFascicoloForm();
    }
  }

  createFascicoloForm(init = false) {
      this.datiGeneraliForm = this.campiForm.group({
        dataInizioFascicolo: [init ? null : this.request.fascicolo.dataInizioFascicolo, Validators.required],
        natura: [this.naturaSelected, Validators.required],
        tipoVisibilita: [init ? null : this.request.fascicolo.tipoVisibilita],
        societa: [init ? null : this.request.fascicolo.societa],
        recuperoCrediti: [init ? false : this.request.fascicolo.recuperoCrediti],
        foro: [init ? null : this.request.fascicolo.foro, Validators.required],
        conciliazione: [init ? null : this.request.fascicolo.conciliazione, Validators.required],
        note: [init ? null : this.request.fascicolo.note],
        flagFondoRischi: [init ? null : this.request.fascicolo.flagFondoRischi],
        giudice: [init ? null : this.request.fascicolo.giudice],
        sezione: [init ? null : this.request.fascicolo.sezione],
        nruolo: [init ? null : this.request.fascicolo.numeroRuolo],
        annoRuolo: [init ? null : this.request.fascicolo.annoRuolo, Validators.compose([this.formValidationService.anno])],
        metadata: [init ? null : this.request.fascicolo.metadata],
        descrizioneOggetto: [init ? null : this.request.fascicolo.descrizioneOggetto, Validators.required],
      });
    if(this.minervaWizard){
      this.createForm.emit();
    }
    this.readProtocollo()
  }

  populateSelect() {
    this.request.fascicolo.natura = this.naturaSelected;
    if (this.soggettiOptions.length === 0) {
      this.helpers.getSoggetti().subscribe(response => this.soggettiOptions = response);
    }
    if (this.foriOptions.length === 0) {
      this.helpers.getListaFori().subscribe(response => this.foriOptions = response);
    }
    if (this.tipiNatura.length === 0) {
      this.helpers.getTipiNatura().subscribe(response => {
        this.tipiNatura = response;
        this.naturaSelected = this.tipiNatura.find(el => el.label === 'PASSIVO');
        this.request.fascicolo.natura = this.naturaSelected;
      });
    }
  }
  onDataProtocol(value: ProtocolMetadata) {
    if (value) {
      this.request.fascicolo.numeroFascicoloProtocollo = value.dossierNumber;
      this.request.fascicolo.numeroProtocollo = value.protocolNumber;
      this.request.fascicolo.dataProtocollazione = value.protocolTimestamp;
      this.request.fascicolo.oggettoProtocollo = value.subject;
      this.request.fascicolo.senderReceiver = value.senderReceiver;
      this.request.fascicolo.utenteProtocollatore = value.protocolUser;
      this.request.fascicolo.inUscita = value.tipoReg.toLowerCase() === "in uscita";
      this.request.fascicolo.protocolDocuments = value.protocolDocuments.map(d => (d.documentRef));
    } else {
      this.request.fascicolo.numeroFascicoloProtocollo = null;
      this.request.fascicolo.numeroProtocollo = null;
      this.request.fascicolo.dataProtocollazione = null;
      this.request.fascicolo.oggettoProtocollo = null;
      this.request.fascicolo.senderReceiver = null;
      this.request.fascicolo.utenteProtocollatore = null;
      this.request.fascicolo.inUscita = null;
      this.request.fascicolo.protocolDocuments = null;
    }
  }
  readProtocollo() {
    if(this.fascicolo.numeroProtocollo){
      this.protocollo={
      dossierNumber: this.fascicolo.numeroFascicoloProtocollo,
      protocolNumber: this.fascicolo.numeroProtocollo,
      protocolTimestamp: this.fascicolo.dataProtocollazione,
      subject: this.fascicolo.oggettoProtocollo,
      senderReceiver:this.fascicolo.senderReceiver,
      protocolUser: this.fascicolo.utenteProtocollatore,
      tipoReg: this.fascicolo.inUscita ? "IN USCITA" : "IN ENTRATA"
    }}
  }
  isFormMetadataValid(value: boolean){
    this.metadataFormValid = value;
  }

  onRetrieve(value : MetadataExt[]){
    this.request.fascicolo.metadata = value.map(value => value);
  }

  save() {
    this.saveForm.emit();
  }

}
